import React, {useEffect, useState} from 'react';
import {css} from "@emotion/css";
import {FormControl, Grid} from "@mui/material";
import RaikoMaterialOutlinedInput from "../../raikoComponents/raikoInputs/RaikoMaterialOutlinedInput";
import {convertToMobileNumber} from "../../util/numberConvertor";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {LoadingHelper} from "../../util/LoadingHelper";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";
import {dataURLtoFile} from "../../util/converBase64ToImage";
import {
    RaikoBaseCardContainer,
    RaikoGridOneColumn,
    RaikoGridTwoColumn,
    RaikoSectionContainer,
    RaikoNumberInputOutlined
} from "@moeindal/base-raiko-panel-components";


const UserProfileDetailPage = (
    {
        profileDetail,
        setProfileDetail,
        avatarFile,
        setAvatarFile,
        service,
        adminId = -1,
        avatarLoadingState = false
    }) => {

    const snackbarDispatcher = useSnackbarDispatcher()
    const snackbar = new SnackbarHelper(snackbarDispatcher)

    const loadingDispatcher = useLoadingDispatcher()
    const loading = new LoadingHelper(loadingDispatcher)

    useEffect(() => {
        if (profileDetail && profileDetail.firstName) {
            setProfileDataToFields();
        }
    }, [profileDetail])

    function setProfileDataToFields() {
        setFirstName(profileDetail.firstName)
        setLastName(profileDetail.lastName)
        setNationalCode(profileDetail.nationalCode)
        setUserName(profileDetail.username)
        setPhoneNumber(profileDetail.phoneNumber)
    }

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [nationalCode, setNationalCode] = useState("");
    const [userName, setUserName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");

    const [imageFile, setImageFile] = useState(null);
    const [imageId, setImageId] = useState(-1);
    const [image, setImage] = useState(null)

    const [avatarLoading, setAvatarLoading] = useState(avatarLoadingState)

    const onImageChange = (event) => {
        if (event.target.files && event.target.files[0]) {
            setImageFile(event.target.files[0]);
            setImageId(-1)
            setImage(URL.createObjectURL(event.target.files[0]));
        }
    }

    function eraseImage() {
        setImageFile(null)
        setImage(null)
        setImageId(-1)
    }

    function checkFields() {
        let message = ""
        let state = false

        if (firstName.length === 0)
            message = "لطفا نام ادمین را وارد نمایید!"
        else if (lastName.length === 0)
            message = "لطفا نام خانوادگی ادمین را وارد نمایید!"
        else if (nationalCode.length < 8)
            message = "خطا، لطفا کد ملی مدیر را به درستی وارد نمایید!"
        else if (phoneNumber.length !== 11)
            message = "لطفا شماره همراه ادمین را به درستی وارد نمایید!"
        else
            state = true

        snackbar.showWarningMessage(message)

        return state
    }

    function handleUpdateDetail() {
        if (checkFields()) {
            if (adminId >= 0) {
                updateManagerInfo()
            } else {
                updateAdminInfo()
            }
        }
    }

    function updateManagerInfo() {
        loading.show()
        service.updateProfileDetailById(
            adminId,
            {
                "firstName": firstName,
                "lastName": lastName,
                "nationalCode": nationalCode,
                "phoneNumber": phoneNumber
            }).then(response => {
            setProfileDetail(response)
            snackbar.showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            loading.hide()
        }).catch(reason => {
            snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage())
            loading.hide()
        })
    }

    function updateAdminInfo() {
        loading.show()
        service.updateProfileInfo({
            "firstName": firstName,
            "lastName": lastName,
            "nationalCode": nationalCode,
            "phoneNumber": phoneNumber,
            "username":userName
        }).then(response => {
            setProfileDetail(response)
            snackbar.showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            loading.hide()
        }).catch(reason => {
            snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage())
            loading.hide()
        })
    }


    const updateAvatar = (imgSrc, fileName) => {
        loading.show()
        const imageFile = dataURLtoFile(imgSrc, fileName)

        service.updateAdminAvatar(imageFile, adminId)
            .then(response => {
                setAvatarFile(response.downloadUrl)
                snackbar.showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
                loading.hide()
            }).catch(reason => {
            snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage())
            loading.hide()
        })
    }

    return (
        <RaikoBaseCardContainer className={css`margin-top: 1rem`}>
            <RaikoSectionContainer
                title={"حساب کاربری"}
                hasActionButton
                actionButtonOnclick={handleUpdateDetail}
            >
                <RaikoGridOneColumn>
                    {/*<RaikoImageCropper avatarFile={avatarFile} updateAvatar={updateAvatar} loading={avatarLoading}/>*/}
                    {/*<RaikoDivider/>*/}
                    <RaikoGridTwoColumn>
                        <FormControl fullWidth>
                            <RaikoMaterialOutlinedInput
                                labelText={"نام"}
                                value={firstName}
                                onChange={({target}) => {
                                    setFirstName(target.value)
                                }}
                            />
                        </FormControl>

                        <FormControl fullWidth>
                            <RaikoMaterialOutlinedInput
                                labelText={"نام خانوادگی"}
                                value={lastName}
                                onChange={({target}) => {
                                    setLastName(target.value)
                                }}
                            />
                        </FormControl>
                        <FormControl>
                            <RaikoNumberInputOutlined
                                maxLength={"10"}
                                value={nationalCode}
                                setValue={setNationalCode}
                                labelText={"کد ملی"}
                            />
                        </FormControl>

                        <FormControl fullWidth>
                            <RaikoMaterialOutlinedInput
                                placeHolder={"091..."}
                                labelText={"شماره همراه"}
                                className={css`
                                  direction: ltr;
                                  text-align: end;`
                                }
                                value={convertToMobileNumber(phoneNumber)}
                                onChange={({target}) => {
                                    const _phoneNumber = convertToMobileNumber(target.value)
                                    setPhoneNumber(_phoneNumber.replaceAll(" ", ""))
                                }}/>
                        </FormControl>

                        <FormControl fullWidth>
                            <RaikoMaterialOutlinedInput
                                labelText={"نام کاربری"}
                                value={userName}
                                onChange={({target}) => {
                                    setUserName(target.value)
                                }}
                            />
                        </FormControl>

                    </RaikoGridTwoColumn>
                </RaikoGridOneColumn>
            </RaikoSectionContainer>
        </RaikoBaseCardContainer>
    )
}

export default UserProfileDetailPage;
